import React from 'react';
import { useLocation } from 'react-router-dom';
import DarkDashboard from '../components/sprint-dashboard/DarkDashboard';
import ProductivityDashboard from '../components/sprint-dashboard/ProductivityDashboard';
import CommandCenter from '../components/sprint-dashboard/CommandCenter';
import StaffProductivity from '../components/sprint-dashboard/StaffProductivity';

const SprintDashboard = () => {
  const location = useLocation();
  const path = location.pathname;

  if (path === '/sprint-dashboard/productivity') {
    return <ProductivityDashboard />;
  }

  if (path === '/sprint-dashboard/command-center') {
    return <CommandCenter />;
  }

  if (path === '/sprint-dashboard/staff') {
    return <StaffProductivity />;
  }

  // Default: overview (DarkDashboard)
  return <DarkDashboard />;
};

export default SprintDashboard;
